import { FC } from "react";
import ProductFeatureTableRow from "./ProductFeatureTableRow";
import { enumToSelectProps } from "../../../tools/EnumTools";
import { ProductFeatureDTO } from "../../../domain/models/dto/ProductFeatureDTO";
import { ProductFeature } from "../../../domain/models/ProductFeature";
import { ProductFeatureFields } from "../../../domain/enums/productFeatureFieldsEnum";
import { useTranslation } from "react-i18next";
import AddRowsSVG from "../../../components/shared/svg/AddRowsSVG";

interface ProductFeatureTableProps {
    productFeatures: ProductFeature[];
    updateHandler: (productFeature: ProductFeatureDTO) => void;
}

const ProductFeatureTable: FC<ProductFeatureTableProps> = (props) => {
    const { t } = useTranslation();

    return (
        <div className="w-[95%] h-[calc(100vh-150px)] ml-auto mr-auto relative bg-light-bg-700 dark:bg-dark-bg-800 overflow-auto shadow-md rounded-xl">
            <table className="w-full text-sm text-left text-light-text-100 dark:text-dark-text-100">
                <thead className="sticky top-0 text-[14px] font-extralight leading-[16px] text-light-text-100 dark:text-dark-text-100 bg-light-bg-800 dark:bg-dark-bg-900">
                    <tr className="text-center px-2 py-3 group relative">
                        {Object.values(enumToSelectProps(ProductFeatureFields, "console.productFeatures.table")).map(
                            (value) => {
                                return (
                                    <th
                                        key={`th-productFeatures-table-${value.labelKey}`}
                                        className="px-2 py-3 group border-x border-y-0 border-light-border-200 dark:border-dark-border-200 bg-light-bg-800 dark:bg-dark-bg-900"
                                    >
                                        {t(value.labelKey)}
                                    </th>
                                );
                            }
                        )}
                        {/* <th className="px-2 py-3 border-x border-y-0 border-light-border-200 dark:border-dark-border-200 bg-light-bg-800 dark:bg-dark-bg-900">
                            <button
                                className="flex items-center justify-center w-[28px] h-[28px] mx-auto"
                                title={t("console.productFeatures.table.add")}
                            >
                                <AddRowsSVG className="w-[25px] h-[25px] fill-light-fill-100 dark:fill-dark-fill-100" />
                            </button>
                        </th> */}
                    </tr>
                </thead>
                <tbody>
                    {props.productFeatures.map((productFeature) => (
                        <ProductFeatureTableRow
                            key={`tr-productFeature-table-${productFeature.id}`}
                            productFeature={productFeature}
                            updateHandler={props.updateHandler}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ProductFeatureTable;
